const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/settings/skills/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { Spinner } from '@tempo-io/sui-spinner';
import { z } from 'zod';
import i18n from '@/common/translations/i18n';
import { compactBooleanFilterSchema } from '@/common/zod-schemas/common/compactFilterSchemas';
import { getSearchSkillsQueryOptions } from '@/features/settings/skills/queries/useSkillsQuery';
const skillSearchSchema = z.object({
  showCriticalSkills: compactBooleanFilterSchema
});
export const Route = createFileRoute('/(app)/org/$org/settings/skills/')({
  validateSearch: zodValidator(skillSearchSchema),
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  loader: async ({
    context: {
      queryClient
    }
  }): Promise<LoaderData> => {
    await queryClient.ensureQueryData(getSearchSkillsQueryOptions());
    return {
      crumb: i18n.t($ => $.common.settings.skills.label)
    };
  },
  pendingComponent: () => <div className="flex items-center justify-center h-full">
      <Spinner size={32} />
    </div>,
  staticData: {
    topNav: {
      title: i18n.t($ => $.common.settings.skills.label)
    }
  }
});